module.exports = __webpack_public_path__ + "img/songdoconvensia.ffbc117f.png";